<template>
  <b-container fluid class="p-0">
    <b-row align-h="between">
      <b-col
        md="6"
        lg="6"
        sm="4"
        xl="6"
        v-if="filtermaxrows ? totalRows <= filtermaxrows : true"
      >
        <div>
          <div class="form-group d-flex">
            <input
              class="form-control input-search-table"
              id="filterInput"
              v-model="filter"
              autocomplete="search-datatable"
              debounce="500"
              type="search"
              :placeholder="$t('datatable.typetosearch')"
            />
            <!-- <b-button :disabled="!filter" @click.prevent="filter = ''" class="d-none d-lg-block">{{ $t('datatable.clear') }}</b-button> -->
          </div>
        </div>
      </b-col>

      <b-col v-if="perpage < 999" class="my-1 ml-auto" align-self="center">
        <div class="float-right">
          <label class="mr-1 text-total-result">Total de Resultados:</label>
          <span style="padding-right:1rem ;color: #F28C02; font-weight: 400;">{{
            totalRows
          }}</span>
          <label for="perPageSelect" class="mr-2 text-register-page">{{
            $t('datatable.recordsperpage')
          }}</label>
          <b-form-select
            class="custom-select-2"
            id="perPageSelect"
            v-model="perpage"
            size="sm"
            style="width: 60px"
            :options="pageoptions"
          >
          </b-form-select>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="p-0">
        <b-table
          ref="table"
          class="m-0"
          striped
          small
          :items="baseProvider"
          :fields="tableheaders"
          :per-page="perpage"
          :current-page="currentPage"
          :busy="isBusy"
          :filter="filter"
          :sort-by.sync="sortby"
          :sort-desc.sync="sortdesc"
          :responsive="responsiveTable"
          show-empty
          @filtered="onFiltered"
        >
          <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
            <slot :name="slot" v-bind="scope" />
          </template>
          <template v-slot:table-busy>
            <div class="text-center text-corp my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong> {{ $t('datatable.loading') }}...</strong>
            </div>
          </template>
          <template #empty>
            <div class="box-card-search">
              <div class="overlay-card-search">
                <span class="content-icon">
                  <i class="fas fa-exclamation-triangle"></i>
                </span>
                <span class="title-card-search"
                  >No se encontraron datos en la búsqueda</span
                >
                <span class="subtitle-card-search"
                  >Realiza una nueva consulta</span
                >
              </div>
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-row align-h="end" class="mt-1">
      <b-col v-if="perpage < 999" offset-md="5" sm="7" md="3" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perpage"
          prev-text="Ant."
          next-text="Sig."
          align="right"
          size="md"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'BaseDatatable',
  props: {
    drfprovider: {
      type: Function,
      required: false,
      default: () => null,
    },
    provider: {
      type: Function,
      required: false,
      default: () => null,
    },
    tableheaders: {
      type: [Array, Object],
      required: true,
    },
    perpage: {
      type: Number,
      required: false,
      default: 10,
    },
    pageoptions: {
      type: Array,
      required: false,
      default() {
        let pages = []
        let perpage = this.perpage
        for (let index = 1; index <= 5; index++) {
          pages.push(index * perpage)
        }
        pages.push(perpage * 10)
        return pages
      },
    },
    sortby: {
      type: String,
      required: false,
      default: '',
    },
    sortdesc: {
      type: NaN,
      required: false,
      default: null,
    },
    emptyText: {
      type: String,
      default: 'Sin registros para mostrar',
    },
    emptyFilteredText: {
      type: String,
      default: 'No se encontraron registros',
    },
    responsiveTable: {
      type: Boolean,
      default: true,
      required: false,
    },
    fixed: {
      type: Boolean,
      default: false,
      required: false,
    },
    filtermaxrows: {
      type: Number,
      default: null,
      required: false,
    },
  },
  data() {
    return {
      isBusy: false,
      filter: null,
      totalRows: 1,
      currentPage: 1,
      lastFilter: '',
    }
  },
  methods: {
    onFiltered(filteredItems) {
      if (this.filter !== this.lastFilter) {
        // Trying to resolve filter search issues when
        // changing pages with an active filter
        this.currentPage = 1
        this.lastFilter = this.filter
      }
    },
    baseProvider(ctx) {
      // fix: por requerimiento, cuando se escriba el 3er dígito comienza la búsqueda ( JMG - feb-14-2022)
      if (this.filter && this.filter.length < 3) return ctx
      // TODO: si el resultado anterior respondió 0 registros y el nuevo filtro.length < 3
      let promise = this.drfprovider(ctx)
      if (promise) {
        return promise.then((data) => {
          this.totalRows = data.count
          return data.results
        })
      } else {
        return this.provider(ctx)
      }
    },
    refresh() {
      this.$refs.table.refresh()
    },
  },
}
</script>
<style lang="scss">
.table-responsive {
  max-height: 593px !important;
  max-width: 100% !important;
  border-top: 1px solid #ccc !important;
  border-bottom: 1px solid #ccc !important;
}

/* Tamaño del scroll */
.table-responsive::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

/* Estilos barra (thumb) de scroll */
.table-responsive::-webkit-scrollbar-thumb {
  background: #245e8e;
  border-radius: 11px;
}

.table-responsive::-webkit-scrollbar-thumb:active {
  background-color: #999999;
}

.table-responsive::-webkit-scrollbar-thumb:hover {
  background: #245e8e;
  box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.2);
}

/* Estilos track de scroll */
.table-responsive::-webkit-scrollbar-track {
  background: #f2f2f2;
}

.table-responsive::-webkit-scrollbar-track:hover,
.table-responsive::-webkit-scrollbar-track:active {
  background: #f2f2f2;
}

.table thead th {
  border-top: none !important;
}

.table thead th {
  background-color: white;
  color: #535353;
  font-weight: 600;
  font-size: 12px;
  letter-spacing: -0.24px;
  border-bottom: none;
  text-align: left;
  height: 36px;
  padding-top: 6.27;
  padding-bottom: 19.73px;
  vertical-align: text-top !important;
}

.table tbody tr {
  height: 36px;
}

.table tbody td {
  text-align: left;
  color: #656565;
  font-weight: 400;
  text-align: left;
  letter-spacing: 0px;
  min-width: 200px !important;
}

.table tbody tr {
  background-color: #e8f1f9;
}

.table tbody tr:nth-child(2n) {
  background-color: white;
}

.table tbody tr td:first-child,
.table thead tr th:first-child {
  position: sticky !important;
  position: -webkit-sticky !important;
  z-index: 2 !important;
  left: 0 !important;
  min-width: 200px !important;
}

.table tbody tr td:nth-child(2),
.table thead tr th:nth-child(2) {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: 200px !important;
  z-index: 2 !important;
  border-right: 1px solid #ccc !important;
  min-width: 200px !important;
}

.table tbody tr td:last-child,
.table thead tr th:last-child {
  position: sticky !important;
  position: -webkit-sticky !important;
  right: 0 !important;
  z-index: 2 !important;
  border-left: 1px solid #ccc !important;
  min-width: 120px !important;
}

.table thead tr th:last-child {
  padding-bottom: 0 !important;
}

.table tbody tr td:first-child,
.table tbody tr td:last-child {
  background-color: #e8f1f9;
}

.table tbody tr:nth-child(2n) td:first-child,
.table tbody tr:nth-child(2n) td:last-child {
  background-color: #ffffff;
}

.table tbody tr td:first-child,
.table tbody tr td:last-child {
  background-color: #e8f1f9;
}

.table tbody tr td:nth-child(2) {
  background-color: #e8f1f9;
}

.table tbody tr:nth-child(2n) td:nth-child(2) {
  background-color: #ffffff;
}

.title-actions d-flex justify-content-center {
  position: relative;
  // top: 10px;
}
.content-actions {
  font-size: 9px !important;
  color: #707070 !important;
  font-weight: 400 !important;
  justify-content: space-around;
  padding-top: 7.43px;
  margin-bottom: 1.31px !important;
}

.input-search-table {
  width: 50%;
}

.text-total-result {
  color: #484848;
  font-weight: 400;
  font-size: 12px;
  letter-spacing: 0px;
}

.text-register-page {
  color: #7e7e7e;
  font-weight: 400;
  font-size: 10px;
  letter-spacing: 0px;
}

.custom-select-2 {
  border: 0.5px solid rgba(155, 155, 155, 1) !important;
  border-radius: 4px !important;
  width: 50px !important;
  padding-right: 0;
  height: 25px !important;
  background-color: white !important;
  border-radius: 4px;
  line-height: 1.2;
  background-image: url('../assets/images/proximo.png'),
    linear-gradient(to bottom, #ffffff 0%, #ffffff 100%);
  background-repeat: no-repeat, repeat;
  background-position: right 0.7em top 50%, 0 0;
  background-size: 0.65em auto, 100%;
}

.custom-select-2 option {
  color: #000000;
  font-weight: 400;
  font-size: 12px;
}

.pagination {
  // width: 349px;
  height: 38px;
}

.pagination .page-item {
  border-color: #dededf;
  border-radius: 4px;
}

.page-item.active .page-link {
  z-index: 3;
  color: #fff;
  background-color: #1689be !important;
  border-color: #dededf !important;
}

.pagination .page-link {
  font-size: 12px;
  font-weight: 400;
  color: #000000;
  letter-spacing: -0.24px;
}

.pagination li:first-child,
.pagination li:last-child {
  display: none;
}

.pagination li:nth-child(2) {
  color: #5d5d5d;
  font-weight: 400;
  font-size: 10px;
}

.pagination li:nth-child(2) .page-link {
  border-top-left-radius: 4px !important;
  border-bottom-left-radius: 4px !important;
  width: 70px !important;
}

.pagination li:nth-last-child(2) .page-link {
  border-top-right-radius: 4px !important;
  border-bottom-right-radius: 4px !important;
  width: 70px !important;
}

.pagination li:nth-child(2) .page-link::before {
  content: url('../assets/images/flecha-hacia-abajo.svg');
  margin-right: 6.22px;
}

.pagination li:nth-last-child(2) .page-link::after {
  content: url('../assets/images/flecha-derecha.png');
  margin-left: 6.22px;
}

/*** VERSION TABLETS ***/
@media only screen and (min-width: 768px) and (max-width: 992px) {
  .table tbody td {
    min-width: 200px !important;
  }
  .table tbody tr td:first-child,
  .table thead tr th:first-child {
    position: relative !important;
    min-width: 200px !important;
  }
  .table tbody tr td:nth-child(2),
  .table thead tr th:nth-child(2) {
    position: relative !important;
    min-width: 200px !important;
    left: 0 !important;
    border: none !important;
  }

  .input-search-table {
    width: 100%;
  }
}

/*** VERSION CELULAR ***/
@media only screen and (max-width: 767px) {
  .input-search-table {
    width: 100%;
  }

  .table tbody td {
    min-width: 200px !important;
  }
  .table tbody tr td:first-child,
  .table thead tr th:first-child {
    position: relative !important;
    min-width: 200px !important;
  }
  .table tbody tr td:nth-child(2),
  .table thead tr th:nth-child(2) {
    position: relative !important;
    min-width: 200px !important;
    left: 0 !important;
    border: none !important;
  }
}

/*** VERSION CELULAR PEQUEÑO ***/
@media only screen and (max-width: 320px) {
  .table tbody td {
    min-width: 200px !important;
  }
  .table tbody tr td:first-child,
  .table thead tr th:first-child {
    position: relative !important;
    min-width: 200px !important;
  }
  .table tbody tr td:nth-child(2),
  .table thead tr th:nth-child(2) {
    position: relative !important;
    min-width: 200px !important;
    left: 0 !important;
    border: none !important;
  }
}
</style>
